var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConnect2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.666 45.4556C35.0924 45.4556 45.166 35.382 45.166 22.9556C45.166 10.5292 35.0924 0.455566 22.666 0.455566C10.2396 0.455566 0.166016 10.5292 0.166016 22.9556C0.166016 35.382 10.2396 45.4556 22.666 45.4556Z",
    fill: "#2350F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.666 11.1523C16.1577 11.1523 10.8628 16.4473 10.8628 22.9556V27.8456C10.8628 29.0543 11.9215 30.0375 13.2234 30.0375H14.4038C14.7168 30.0375 15.017 29.9131 15.2384 29.6918C15.4597 29.4704 15.5841 29.1702 15.5841 28.8572V22.7868C15.5841 22.4737 15.4597 22.1735 15.2384 21.9522C15.017 21.7308 14.7168 21.6065 14.4038 21.6065H13.332C13.9883 17.0386 17.9188 13.513 22.666 13.513C27.4133 13.513 31.3437 17.0386 32 21.6065H30.9283C30.6152 21.6065 30.315 21.7308 30.0937 21.9522C29.8723 22.1735 29.7479 22.4737 29.7479 22.7868V30.0375C29.7479 31.3394 28.6892 32.3981 27.3873 32.3981H25.0267V31.2178H20.3054V34.7588H27.3873C29.9911 34.7588 32.1086 32.6413 32.1086 30.0375C33.4105 30.0375 34.4692 29.0543 34.4692 27.8456V22.9556C34.4692 16.4473 29.1743 11.1523 22.666 11.1523Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.166016 0.455566)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnect2);
export default __webpack_public_path__ + "static/media/icon-connect2.95cd5d90f82139a825e7a529ccf8130a.svg";
export { ForwardRef as ReactComponent };